module.exports = __webpack_public_path__ + "static/img/3.f72e21e7.png";